module.exports = __webpack_public_path__ + "img/icon1-2@2x.da91e957.png";